import { ErrorResponse, GlobalVariableValues, MessageParameters, operationEntryTypeEnum, OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, getManager, Raw, Repository } from 'typeorm';
import { OperationDTO } from './dto/operations.dto';
import { OperationDto, OperationResponseModel, AllOperationsResponseModel, VarientIdRequest, OperationsDropDown, OperationsDropDownResponse, OperationandLotReq, operationReq, LotAndSaleOrderIdReq, LotClubbingViewReq } from '@gtpl/shared-models/production-management';
import { Operations } from './operations.entity';
import { OperationsAdapter } from './dto/operations.adapter';
import { OperationRequest } from './dto/operations.request';
import { VariantOperationRepository } from '../variant-operations/repository/variant-operation.repository';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { CommonResponse, PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import appSettings from 'apps/services/config';
import moment from 'moment';
import { whatsApp } from '../../../../whatsapp'
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { Cron } from '@nestjs/schedule';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'


@Injectable()
export class OperationsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Operations)
        private operationsRepository: Repository<Operations>,
        private operationsAdapter: OperationsAdapter,
        private variantOperationService : VariantOperationsService,
        private wpService: WhatsAppNotificationService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
    ) { }


    /**
     * To create an operation
     * @param operationDto 
     * @param isUpdate 
     * @returns OperationResponseModel
     */
    async createOperation(operationDto: OperationDTO, isUpdate: boolean): Promise<OperationResponseModel> {
        try {
            // to check whether operation exists with the passed  operation  or not. if isUpdate is false, a check will be done whether a record with the passed operation is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed operation  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const operationEntity = await this.getOperationDetailsWithoutRelations(operationDto.operationName);
                if (operationEntity) {
                    throw new ErrorResponse(11104, 'Operation already exists');
                }
            } else {
                const operationEntity = await this.getOperationDetailsWithoutRelationsForUpdate(operationDto.operationCode, operationDto.operationName, operationDto.operationId);
                if (operationEntity) {
                    if(operationEntity.operationId != operationDto.operationId){
                       throw new ErrorResponse(11104, 'Operation already exists');
                    }  
                }
            }
           
            const convertedOperationEntity: Operations = this.operationsAdapter.convertDtoToEntity(operationDto, isUpdate);
            const savedOperationEntity: Operations = await this.operationsRepository.save(
                convertedOperationEntity
            );
            const savedOperationDto: OperationDTO = this.operationsAdapter.convertEntityToDto(savedOperationEntity);
            if (savedOperationDto) {
                // generating resposnse
                const response = new OperationResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Operation Updated Successfully' : 'Operation Created Successfully', savedOperationDto);
                // const name=isUpdate?'updated':'created'
                // const newLogDto = new LogsDto(1,name, 'Operations', savedOperationDto.operationId, true, '',savedOperationDto.createdUser)
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Operation saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
        }
    }
    async getOperationDetailsWithoutRelations(operationName: string): Promise<Operations> {
        // tslint:disable-next-line: typedef
        const operationResponse = await this.operationsRepository.findOne({
            where: {operationName: Raw(alias => `operation_name = '${operationName}'`) },
        });
        if (operationResponse) {
            return operationResponse;
        } else {
            return null;
        }
    }
    async getOperationDetailsWithoutRelationsForUpdate(operationCode: String, operationName: String, id:number): Promise<Operations> {
        // tslint:disable-next-line: typedef
        const responseCode = await this.operationsRepository.findOne({
            where: { operationCode: operationCode},
        });
        const responseName = await this.operationsRepository.findOne({
            where: { operationName: operationName},
        });
        if (responseCode || responseName) {
            if(responseCode && responseName){
                if(responseCode.operationId == responseName.operationId){
                    return responseCode;
                }
                else if( responseCode.operationId == id){
                    return responseName;
                }
                else if( responseName.operationId == id){
                    return responseCode;
                }
                else{
                    return responseCode;
                }
            }
            else if(responseCode && !responseName){
                return responseCode;
            }
            else if(responseName && !responseCode){
                return responseName;
            }
        } else {
            return null;
        }
    }
    /**
     * To retrieve all operations from the database
     * @returns all operations
     */
    async getAllOperations(inputReq: VarientIdRequest): Promise<AllOperationsResponseModel> {
        // const page: number = 1;
        try {
            const operationDTO: OperationDto[] = [];

            const variantOperationData = await this.variantOperationService.getOperationsAssignedByVarientId(new VarientIdRequest(inputReq.variantId));
            if(variantOperationData.length > 0){
                variantOperationData.forEach(operationEntity => {
                    const convertedendOperationsDto= new OperationDto(operationEntity.operationId, operationEntity.operationCode, operationEntity.operationName, undefined, undefined,operationEntity.isValueAddition,operationEntity.isActive, operationEntity.createdUser, operationEntity.updatedUser, operationEntity.versionFlag,true);
                    operationDTO.push(convertedendOperationsDto);
                });
                const response = new AllOperationsResponseModel(true, 11108, "Variant Operations retrieved successfully", operationDTO);
                return response;
            }else{

                const operationsEntities: Operations[] = await this.operationsRepository.find({
                relations: ["workstationCategoryInfo"],
                   order: { operationId: 'ASC' },
             });
                if (operationsEntities) {
                    // converts the data fetched from the database which of type companies array to type StateDto array.
                    operationsEntities.forEach(operationEntity => {
                        const convertedendOperationsDto= new OperationDto(operationEntity.operationId, operationEntity.operationCode, operationEntity.operationName, operationEntity.workstationCategoryInfo.workstationCategoryId, operationEntity.workstationCategoryInfo.workstationCategory,operationEntity.isValueAddition, operationEntity.isActive, operationEntity.createdUser, operationEntity.updatedUser, operationEntity.versionFlag,false);
                        operationDTO.push(convertedendOperationsDto);
                    });
                        
                    const response = new AllOperationsResponseModel(true, 11108, "Operations retrieved successfully", operationDTO);
                    // const newLogDto = new LogsDto(1,'view', 'Operations', 0, true, '','')
                    // let res = await this.logService.createLog(newLogDto);
                    // console.log(res);
                    return response;
                } else {
                    throw new ErrorResponse(99998, 'Data not found'); 
                }
            }
        } catch (err) {
            throw err;
        }
    }
    async activateOrDeactivateOperation(OperationReq: OperationRequest): Promise<OperationResponseModel> {
        try {
            const operationExists = await this.getOperationById(OperationReq.operationId);
            if (operationExists) {
                if (OperationReq.versionFlag !== operationExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Operation information.Refresh and try again');
                } else {

                    const operationStatus = await this.operationsRepository.update(
                        { operationId: OperationReq.operationId },
                        { isActive: OperationReq.isActive, updatedUser: OperationReq.updatedUser });

                    if (operationExists.isActive) {
                        if (operationStatus.affected) {
                            const operationResponse: OperationResponseModel = new OperationResponseModel(true, 10115, 'Operation is de-activated successfully');
                            return operationResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Operation is already deactivated');
                        }
                    } else {
                        if (operationStatus.affected) {
                            const operationResponse: OperationResponseModel = new OperationResponseModel(true, 10114, 'Operation is activated successfully');
                            return operationResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Operation is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getOperationById(operationId: number): Promise<Operations> {
        const Response = await this.operationsRepository.findOne({
        where: {operationId: operationId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }

    async getAllOperationsDropDown():Promise<OperationsDropDownResponse>{
        try {
            const response: OperationsDropDown[] = await this.operationsRepository.createQueryBuilder('operations')
                .select('operation_id as operationId, operation_name as operationName, workstation_category_id as workstationCategoryId')
                .getRawMany();
            if(response&&response.length){
                return new OperationsDropDownResponse(true, 1111, 'Operations Data Retrieved Successfully', response);
            }else{
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error;
        }
    }
    
    async GetAllLotInformationAginstOperationandlot(req:OperationandLotReq):Promise<CommonResponse>{
        try{
            const manager=getManager();
            let query;
            const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
            const plantresult =await manager.query(plantquery);
            const versionBasedAvailableQtyCond = GlobalVariableValues.productionVersion == 'V1' ? `(physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity)` : `IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',(wip_quantity - issued_quantity) , (physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity-clubbed_quantity))`
            const versionBasedPhyQtyCond = GlobalVariableValues.productionVersion == 'V1' ? `physical_quantity` : `IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',wip_quantity,physical_quantity)`
             query = 'SELECT pi.sale_order_item_id as saleOrderItemId,operation,sub_lot_number as subLotNumber,pi.plant_id plantId,pi.sub_plant_id,op_boxes,'+versionBasedAvailableQtyCond+' AS availableQuantity,'+versionBasedPhyQtyCond+' AS physicalQuantity,si.po_number,variant_code,pi.sale_order_id as saleOrderId,lot_number,CONCAT(si.po_number,"-",variant_code) AS salOrderandItem FROM '+appSettings.production_db+'.production_inventory pi LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON si.sale_order_id=pi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items soi ON soi.sale_order_item_id=pi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk ON sk.sku_code_id=soi.varient_id where operation="'+req.operation+'" and lot_number ="'+req.lotNumber+'" and pi.entry_type = "'+operationEntryTypeEnum.OUT+'" '

            if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
                query = query+' and pi.sub_plant_id='+req.plant+' '
            }else{
                query = query+ 'and pi.plant_id='+req.plant+' and  pi.sub_plant_id=0' 
            }
            if(req.count != undefined){
                query += ` and output_grade = '${req.count}' `
            }
            if(req.year != undefined){
                query += ` and year = ${req.year} `
            }
             if(req.product != undefined){
                query += ` and out_product = '${req.product}'`
            }
            query = query+' group by pi.sale_order_item_id'
            const result = await manager.query(query);
            if(result){
                return new CommonResponse(true,1000,'Dtata retrived sucessfully',result)
            }
            else{
                return new CommonResponse(false,1000,'Dtata retrived sucessfully')

            }
        }catch(err){
            return err
        }
    }
    async getLotNumbersDropDownForLotClub(req:operationReq):Promise<CommonResponse>{
        try{
            const manager=getManager();
            let query;     
             const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
             const plantresult =await manager.query(plantquery);
             const versionBasedQtyCond = GlobalVariableValues.productionVersion == 'V1' ? `ROUND(physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty)` : `IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',wip_quantity - issued_quantity,ROUND(physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty - clubbed_quantity) )`
             const versionBasedWhereCond = GlobalVariableValues.productionVersion == 'V1' ? `(physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty) > 0` : `IF(operation = '${OperationTypeEnum.VALUE_ADDITION}',(wip_quantity-issued_quantity) > 0 , (physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty - clubbed_quantity) > 0)`
            //  query = ' SELECT DISTINCT pi.lot_number as lotNumber,CONCAT(pi.sub_lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) AS sublotnplsntlot,CONCAT(pi.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) AS concatLotNum,g.remarks as plantLotNumber,operation,plant_id,sub_plant_id,sub_lot_number AS subLotNumber,op_boxes as opBoxes,'+versionBasedQtyCond+' as quantity,pi.input_grade,pi.output_grade,pi.prod_inv_id,pi.product,pi.year FROM '+appSettings.production_db+'.production_inventory pi left join '+appSettings.rm_procure_db+'.grn_items g ON g.lot_number=pi.lot_number WHERE '+versionBasedWhereCond+' AND operation="'+req.operation+'" '
             query = ' SELECT pi.lot_number as lotNumber,pi.lot_number  AS sublotnplsntlot,pi.lot_number AS sublotnplsntlot,pi.lot_number as plantLotNumber,pi.lot_number AS concatLotNum,operation,plant_id,sub_plant_id,sub_lot_number AS subLotNumber,op_boxes as opBoxes,'+versionBasedQtyCond+' as quantity,pi.input_grade,pi.output_grade,pi.prod_inv_id,pi.product,pi.year,sku.short_code as outProduct,pi.out_product as outProductId,pi.out_count_type FROM '+appSettings.production_db+' .production_inventory pi LEFT JOIN '+appSettings.masters_db+' .sku_codes sku ON sku.sku_code_id = pi.out_product WHERE pi.entry_type = "'+operationEntryTypeEnum.OUT+'" AND  '+versionBasedWhereCond+' AND operation = "'+req.operation+'" AND prev_operation = "'+req.prevOperation+'" '
             
             if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
                query = query+' and sub_plant_id='+req.plant+''
             }else{
                query = query+' and plant_id='+req.plant+' and sub_plant_id=0'
             }
            const result = await manager.query(query);
            if(result){
                return new CommonResponse(true,1000,'Dtata retrived sucessfully',result)
            }
            else{
                return new CommonResponse(false,1000,'Dtata retrived sucessfully')

            }
        }catch(err){
            return err
        }
    }
    
    @Cron('0 8 * * *')
    async getProductionUsage ():Promise<CommonResponse>{
        const manager = getManager();
        let deheadingQuery = `SELECT COUNT(pl.operation) AS cnt , uc.unit_name FROM erpx_dev_production.production_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id
        WHERE pl.operation = 'DEHEADING' AND DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id `
        let gradingQuery = `SELECT COUNT(pl.operation) AS cnt , uc.unit_name FROM erpx_dev_production.production_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id
        WHERE pl.operation = 'GRADING' AND DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id`
        let valueAdditionQuery = `SELECT COUNT(pl.operation) AS cnt , uc.unit_name FROM erpx_dev_production.production_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id
        WHERE pl.operation = 'VALUE ADDITION' AND DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id`
        let soakingQuery = `SELECT COUNT(pl.operation) AS cnt , uc.unit_name FROM erpx_dev_production.production_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id
        WHERE pl.operation = 'SOAKING' AND DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id`
        let freezingQuery = `SELECT COUNT(pl.operation) AS cnt , uc.unit_name FROM erpx_dev_production.production_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id
        WHERE pl.operation = 'FREEZING' AND DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id`
        let stockTransfers = `SELECT COUNT(pl.created_at) AS cnt , uc.unit_name FROM ${appSettings.production_db}.stock_transfer_log pl 
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = pl.plant_id 
        WHERE DATE(pl.created_at) = DATE_SUB(CURDATE(), INTERVAL 1 DAY)
        GROUP BY pl.plant_id `

        const deheadingData = await manager.query(deheadingQuery);
        const gradingData = await manager.query(gradingQuery);
        const valueAdditionData = await manager.query(valueAdditionQuery);
        const soakingData = await manager.query(soakingQuery);
        const freezingData = await manager.query(freezingQuery);
        const stockTransferData = await manager.query(stockTransfers);

        let deheadUsage = "";
        let gradingUsage = "";
        let valueAdditionUsage = "";
        let soakingUsage = "";
        let freezingUsage = "";
        let stockTransferUsage = "";

        const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
        const nowTime = moment().subtract(0, "days").format('MMMM Do, YYYY')

        if (deheadingData.length > 0) {
            for (const sd of deheadingData) {
                deheadUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          }
        if (gradingData.length > 0) {
            for (const sd of gradingData) {
                gradingUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          }
        if (valueAdditionData.length > 0) {
            for (const sd of valueAdditionData) {
                valueAdditionUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          } 
        if (soakingData.length > 0) {
            for (const sd of soakingData) {
                soakingUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          }
        if (freezingData.length > 0) {
            for (const sd of freezingData) {
                freezingUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          }
        if (stockTransferData.length > 0) {
            for (const sd of stockTransferData) {
                stockTransferUsage += sd.unit_name + " :  *" + sd.cnt + "* ";
            }
          }
         
        const parameters = [
            { "type": "text", "text": time + ` (${whatsApp.server})` },
            { "type": "text", "text": deheadingData.length > 0 ? deheadUsage : "No Data" },
            { "type": "text", "text": gradingData.length > 0 ? gradingUsage : "No Data" },
            { "type": "text", "text": valueAdditionData.length > 0 ? valueAdditionUsage : "No Data" },
            { "type": "text", "text": soakingData.length > 0 ? soakingUsage : "No Data" },
            { "type": "text", "text": freezingData.length > 0 ? freezingUsage : "No Data" },
            { "type": "text", "text": stockTransferData.length > 0 ? stockTransferUsage : "No Data" },
        ]  
        const contacts = whatsApp.contacts;
        let statusFlag = true;

        for (const contact of contacts) {
            const req = await new MessageParameters(contact, 'production_usage', parameters, 'en_us')
            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
            console.log(messageStatus)
            if (!messageStatus.status) {
              statusFlag = false
            }else{
                statusFlag = true
                const whatsapplogDto = new WhatsAppLogDto(contact,'logistics_uasage_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.salemoduleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
            }
          }
          if (statusFlag) {
            return new CommonResponse(true, 11108, "Message Sent Sucessfully")
          }
    }

    async getLotNumbersDropDownForRejections(req:PlantIdRequest):Promise<CommonResponse>{
        try{
            const manager=getManager();
            let query;     
             const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitcodeId;
             const plantresult =await manager.query(plantquery);
             query = ' SELECT pi.operation,pi.sub_lot_number as subLotNumber, pi.lot_number as lotNumber,CONCAT(pi.sub_lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) AS sublotnplsntlot,CONCAT(pi.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) AS concatLotNum,g.remarks as plantLotNumber,operation,plant_id,sub_plant_id,sub_lot_number AS subLotNumber,op_boxes as opBoxes,ROUND(physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty) as quantity FROM '+appSettings.production_db+'.production_inventory pi left join '+appSettings.rm_procure_db+'.grn_items g ON g.lot_number=pi.lot_number WHERE wip_quantity >0'
             if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
                query = query+' and sub_plant_id='+req.unitcodeId+''
             }else{
                query = query+' and plant_id='+req.unitcodeId+' and sub_plant_id=0'
             }
              query = query + ' GROUP BY pi.sub_lot_number'
            const result = await manager.query(query);
            if(result){
                return new CommonResponse(true,1000,'Dtata retrived sucessfully',result)
            }
            else{
                return new CommonResponse(false,1000,'Dtata retrived sucessfully')

            }
        }catch(err){
            return err
        }
    }

    async getAllOperationsAgainistlotAndsoId(req:LotAndSaleOrderIdReq):Promise<CommonResponse>{
        const manager = getManager();
        const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plantId;
        const plantresult =await manager.query(plantquery);
        let query='SELECT operation as operationName,lot_number AS lotNumber,sub_lot_number AS subLotNumber  FROM '+appSettings.production_db+'.production_inventory  where lot_number="'+req.lotNumber+'" and sub_lot_number="'+req.subLotNumber+'" and sale_order_id='+req.saleOrderId+' and sale_order_item_id='+req.saleOrderItemId+' '
        if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
            query = query+' and sub_plant_id='+req.plantId+''
         }else{
            query = query+' and plant_id='+req.plantId+' and sub_plant_id=0'
         }
         query=query+' GROUP BY operation'
        const data = await manager.query(query)
        if(data.length > 0){
            return new CommonResponse(true,1000,'operation retrived sucessfully',data)
        }else{
            return new CommonResponse(true,1000,'no data foun')

        }
    }

    async getAllLotClubbingView():Promise<CommonResponse>{
        const manager = getManager();
        try{
        const query = `SELECT mcl.lot_id,mcl.main_lot_number,mcl.operation,mcl.purpose,mcl.count as count ,mcl.qty_avail,mcl.qty_aft_club,p.prev_operation as prevOperation,sku.short_code as product,p.out_count_type as countType,mcl.new_lot_number as newLotNumber,s.short_code as newProduct,mcl.count_type as newCountType,mcl.clubbed_qty as clubbedQty,mcl.new_count as newCount
        FROM ${appSettings.production_db} .master_clubbed_lots mcl 
        LEFT JOIN ${appSettings.production_db} .production_inventory p ON p.prod_inv_id = mcl.prod_inv_id
        LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = p.out_product
        LEFT JOIN ${appSettings.masters_db} .sku_codes s ON s.sku_code_id = mcl.new_product
        `

        const infoQuery= await manager.query(query)
        if(infoQuery.length > 0){
            return new CommonResponse(true,1000,'lotclubbingview retrived sucessfully',infoQuery)
        }else{
            return new CommonResponse(true,1001,'no data found')
        }

        }catch(error){
            return error
        }
    }
    async getAllLotClubbingChildView(req:LotClubbingViewReq):Promise<CommonResponse>{
        const manager = getManager();
        try{
        let query = `   SELECT ccl.lot_number, quantity, ccl.count, master_lot_id ,ccl.clubbed_quantity as clubbedQty,ccl.count_type as countType,sku.short_code as product,prev_operation as prevOperation,operation
        FROM ${appSettings.production_db} .child_clubbed_lots ccl
        LEFT JOIN ${appSettings.production_db} .production_inventory pi ON pi.prod_inv_id = ccl.prod_inv_id
        LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = pi.out_product
        WHERE 1 = 1`
        
        if(req.lotId){
            query += ` AND ccl.master_lot_id = '${req.lotId}'`
        }
        const infoQuery= await manager.query(query)
        if(infoQuery.length > 0){
            return new CommonResponse(true,1000,'lotclubbingchildview retrived sucessfully',infoQuery)
        }else{
            return new CommonResponse(true,1001,'no data found')
        }

        }catch(error){
            return error
        }
    }
   
}
